import styled from "@emotion/styled";
import { motion } from "framer-motion";

const SubmitButton = styled(motion.button)(() => ({
  outline: "none",
  border: "none",
  marginTop: 10,
  marginBottom: 50,
  fontSize: 20,
  fontWeight: "bold",
  padding: "10px 20px",
  borderRadius: 8,
  backgroundColor: "#000",
  color: "white",
  cursor: "pointer",
  "&:disabled": {
    opacity: 0.5,
    cursor: "not-allowed",
  },
}));

export default SubmitButton;
